import { ResourceDto, ResourcesApi } from '../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

const QUERY_KEY = 'resources';

type UseGetResources = (
  options?: Omit<
    UseQueryOptions<ResourceDto[], ErrorResponse, ResourceDto[], string[]>,
    'queryKey' | 'queryFn'
  >,
) => UseQueryResult<ResourceDto[]>;

export const useGetResources: UseGetResources = (options) => {
  const resourcesApi = new ResourcesApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;

  return useQuery(
    [QUERY_KEY],
    async () => resourcesApi.getResources(tenantId).then((res) => res.data),
    options,
  );
};
